import { useLegalAcceptance } from '~/helpers/legal/use-legal-acceptance'
import LegalAcceptanceDialog from './LegalAcceptanceDialog'
import StatsNoticeDialog from './StatsNoticeDialog'

/**
 * Les fenêtres présentées après connexion, dans leur ordre (#360) : les conditions
 * d'abord, la notice de suivi ensuite. Jamais deux fenêtres l'une sur l'autre, ni la
 * notice qui s'ouvre puis s'efface pendant que les conditions se chargent.
 */
function ConsentDialogs() {
  const { pending, settled } = useLegalAcceptance()

  return (
    <>
      <LegalAcceptanceDialog />
      {settled && pending.length === 0 && <StatsNoticeDialog />}
    </>
  )
}

export default ConsentDialogs
